import React from 'react';
import { GBTypography } from '@leapfinance/geebee-component-library';
var SOPHeader = function (_a) {
    var title = _a.title, renderCTA = _a.renderCTA;
    return (React.createElement("div", { className: "lfc-flex lfc-w-full lfc-justify-between" },
        React.createElement(GBTypography, { variant: "h1Semibold", className: "lfc-block" }, title),
        renderCTA));
};
export default SOPHeader;
//# sourceMappingURL=SOPHeader.js.map